import Plugin from "./Plugin.js";
import { timelineStore } from "@/store/timelineStore";

export default class ListenerPlayTimePlugin extends Plugin{
  timelineStoreState
  editor
  constructor(){
    super()
    this.timelineStoreState = timelineStore();
  }

  init(editor){
    this.editor = editor
    window.addEventListener("play_time_listener", (detail) => {
      const allCardsDurationBeforeActive = this.timelineStoreState.getAllCardsDurationBeforeActive // 前面所有card时长
      let renderTime =  detail.detail.time  - allCardsDurationBeforeActive
      // let displayTime = detail.detail.time - allCardsDurationBeforeActive + 0.5 + 0.3 // 0.5 为动画过渡 0.3暂为渲染差
      // 渲染时长 > 当前卡片的活动时长
      // if( renderTime > this.timelineStoreState.getActiveCardDuration) {
      //   // 下一个卡片
      //     if(this.timelineStoreState.activeCardIndex + 1 < this.timelineStoreState.getCardList.length){
      //       renderTime -= this.timelineStoreState.getActiveCardDuration
      //       this.timelineStoreState.setActiveCardIndex(this.timelineStoreState.activeCardIndex + 1)
      //     } else {
      //       // 播放结束
      //       renderTime = this.timelineStoreState.getActiveCardDuration - 0.01
      //       this.timelineStoreState.setIsPlaying(false)
      //       this.editor.pause()
      //     }
      // }
      this.timelineStoreState.setTimePoint(renderTime)
    });
  }
}
